import { Routing, Search } from "@common/_constants/";
import {
    formatClientRoute,
    UserService,
} from "@common/_services";
import Header from "@common/components/Atoms/Header";
import {
    IconChevronLeft,
    IconClose,
    IconDrawerToggle,
    IconLogoHorizontal,
    IconLogoVertical,
} from "@common/components/Atoms/Icons";
import Loading from "@common/components/Atoms/Loading";
import MessageIndicator from "@common/components/Molecules/MessageIndicator";
import { UserFromStorage } from "@common/models/UserFromStorage";
import { GlobalConfig } from "@common/utils/config";
import { LocationDescriptor } from "history";
import Moment from "moment";
import * as React from "react";
import { Link, NavLink } from "react-router-dom";

declare const window: any;
interface PageInternalState {
    isDrawerOpen: boolean;
    isPastHeaderAttachPoint: boolean;
    isHeaderFixed: boolean;
    user: UserFromStorage;
    version: string;
}

interface PageInternalProps {
    triggerProfileTickle?: boolean;
    triggerMessageIndicator?: boolean;
    updating?: boolean;
    size?: string;
    gray?: boolean;
    className?: string;
    title?: string;
    return?: boolean;
    bgClass?: string;
    center?: React.ReactNode;
    actionsLarge?: React.ReactNode;
    actionsSmall?: React.ReactNode;
    updatingMessage?: string;
    headerTitle?: string;
}

export class PageInternal extends React.Component<PageInternalProps, PageInternalState> {
    constructor(props) {
        super(props);

        this.state = {
            isDrawerOpen: false,
            isHeaderFixed: true,
            isPastHeaderAttachPoint: false,
            user: this.getUser(),
            version: GlobalConfig.version,
        };
        this.affixHeader = this.affixHeader.bind(this);
        this.resetDrawer = this.resetDrawer.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.getUser = this.getUser.bind(this);
        this.updateProfileImage = this.updateProfileImage.bind(this);
    }

    getUser() {
        let user = UserService.getUserFromStorage();
        if (!user) {
            user = {
                displayName: "",
                firstName: "",
                profileImageUrl: "",
                token: "",
                email: "",
                expires: 0,
                roleId: 0,
                applicationName: "",
            };
        }
        return user;
    }

    updateProfileImage() {
        const user = this.getUser();
        this.setState({ user });
    }

    resetDrawer() {
        this.setState({ isDrawerOpen: false });
    }

    toggleDrawer() {
        this.setState({ isDrawerOpen: !this.state.isDrawerOpen });
    }

    affixHeader() {
        const scroll = window.scrollY;
        const breakpoint = 16;
        if (scroll >= breakpoint && !this.state.isPastHeaderAttachPoint) {
            this.setState({ isPastHeaderAttachPoint: true });
        } else if (scroll < breakpoint && this.state.isPastHeaderAttachPoint) {
            this.setState({ isPastHeaderAttachPoint: false });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.triggerProfileTickle !== nextProps.triggerProfileTickle) {
            this.updateProfileImage();
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resetDrawer);
        window.addEventListener("scroll", this.affixHeader);
        document.body.classList.remove("is-external");
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resetDrawer);
        window.removeEventListener("scroll", this.affixHeader);
    }

    render() {
        const pageClasses = ["c-page"];
        const updatingClasses = ["c-page__updating"];
        if (this.props.updating) pageClasses.push("c-page--updating");
        if (this.props.updating) updatingClasses.push("is-visible");
        if (this.props.size) pageClasses.push("c-page--" + this.props.size);
        if (!this.props.size) pageClasses.push("c-page--xl");
        if (this.props.gray) pageClasses.push("c-page--gray");
        if (this.props.className) pageClasses.push(this.props.className);

        const jobsLocation: LocationDescriptor = {
            pathname: Routing.Client.Pro.Jobs.SEARCH,
            search: `${Search.FacetType.JOB_SEARCH_SCOPE.key}=${Search.JobSearchScope.RECOMMENDED}`,
        };

        return (
            <div className="o-site">
                <Header title={this.props.headerTitle ? this.props.headerTitle : this.props.title} />
                <div className="o-site__sprite" />
                <header
                    className={
                        "o-site__header" +
                        (this.state.isHeaderFixed ? " o-site__header--fixed" : "") +
                        (this.state.isPastHeaderAttachPoint ? " is-fixed" : "")
                    }>
                    <nav className="o-site__nav">
                        <div className="o-site__nav-logo">
                            <Link to="/">
                                <IconLogoHorizontal />
                            </Link>
                        </div>
                        <div className="o-site__nav-left">
                            <ul>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Home.DASHBOARD}
                                        exact={true}
                                        className="c-link no-underline"
                                        activeClassName="is-active">
                                        Home
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={jobsLocation}
                                        className="c-link no-underline"
                                        activeClassName="is-active"
                                        target="_top">
                                        Jobs
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Applications.SEARCH}
                                        className="c-link no-underline"
                                        activeClassName="is-active">
                                        Applications
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Referrals.SEARCH}
                                        className="c-link no-underline"
                                        activeClassName="is-active">
                                        Referrals
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="o-site__nav-right">
                            <ul>
                                <li>
                                    <MessageIndicator
                                        triggerMessageIndicator={
                                            this.props.triggerMessageIndicator || false
                                        }
                                    />
                                </li>
                                <li>
                                    <div className="c-dropdown c-dropdown--right">
                                        <div className="c-dropdown__toggle o-site__user">
                                            <span className="o-site__user-image">
                                                <img
                                                    width="28"
                                                    height="28"
                                                    src={this.state.user.profileImageUrl}
                                                    alt={"image: " + this.state.user.displayName}
                                                />
                                            </span>
                                            <span className="o-site__user-name">
                                                {this.state.user.displayName}
                                            </span>
                                        </div>
                                        <div className="c-dropdown__menu">
                                            <NavLink
                                                to={formatClientRoute(
                                                    Routing.Client.Pro.Profile.SETTINGS_PANE,
                                                    {
                                                        pane:
                                                            Routing.Client.Pro.Profile.Panes
                                                                .CONTACT_INFO,
                                                    }
                                                )}
                                                className="c-dropdown__item"
                                                exact={true}
                                                activeClassName="is-active">
                                                Settings
                                            </NavLink>
                                            <NavLink
                                                to={Routing.Client.Pro.Profile.FRIENDS}
                                                className="c-dropdown__item"
                                                exact={true}
                                                activeClassName="is-active">
                                                Friends
                                            </NavLink>
                                            <NavLink
                                                to={Routing.Client.Pro.Profile.ACTIVITY}
                                                className="c-dropdown__item"
                                                exact={true}
                                                activeClassName="is-active">
                                                Activity
                                            </NavLink>
                                            <a
                                                href={Routing.Client.Account.SIGN_OUT}
                                                className="c-dropdown__item">
                                                Sign Out
                                            </a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div
                            className={
                                "o-site__nav-toggle" + (this.state.isDrawerOpen ? " is-active" : "")
                            }>
                            <button onClick={this.toggleDrawer}>
                                <IconDrawerToggle />
                            </button>
                        </div>
                    </nav>
                    <nav className={"o-site__drawer" + (this.state.isDrawerOpen ? " is-open" : "")}>
                        <div className="o-site__drawer-close">
                            <button onClick={this.toggleDrawer}>
                                <IconClose />
                            </button>
                        </div>
                        <div className="o-site__drawer-scroll">
                            <ul>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Home.DASHBOARD}
                                        exact={true}
                                        className="c-link no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        home
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={jobsLocation}
                                        className="c-link no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        jobs
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Applications.SEARCH}
                                        exact={true}
                                        className="c-link no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        applications
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Referrals.SEARCH}
                                        exact={true}
                                        className="c-link no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        referrals
                                    </NavLink>
                                </li>
                            </ul>
                            <ul>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Messages.SEARCH}
                                        exact={true}
                                        className="c-link c-link--magenta no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        messages
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={formatClientRoute(
                                            Routing.Client.Pro.Profile.SETTINGS_PANE,
                                            {
                                                pane: Routing.Client.Pro.Profile.Panes.CONTACT_INFO,
                                            }
                                        )}
                                        exact={true}
                                        className="c-link c-link--magenta no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        settings
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Profile.FRIENDS}
                                        exact={true}
                                        className="c-link c-link--magenta no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        friends
                                    </NavLink>
                                </li>
                                <li>
                                    <NavLink
                                        to={Routing.Client.Pro.Profile.ACTIVITY}
                                        exact={true}
                                        className="c-link c-link--magenta no-underline"
                                        activeClassName="is-active"
                                        onClick={this.toggleDrawer}>
                                        activity
                                    </NavLink>
                                </li>
                                <li>
                                    <a
                                        href={Routing.Client.Account.SIGN_OUT}
                                        className="c-link c-link--magenta no-underline">
                                        sign out
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </header>
                <section
                    className={"o-site__content " + (this.props.bgClass ? this.props.bgClass : "")}>
                    {/*what used to be the PageContent component*/}
                    <section className={pageClasses.join(" ")}>
                        <header className="c-page__header">
                            <div className="c-page__header-container">
                                <div className="c-page__left">
                                    {!this.props.return &&
                                        this.props.title && (
                                            <h1 className="c-page__title" data-cy="page-header-title-h1">{this.props.title}</h1>
                                        )}
                                    {this.props.return &&
                                        !this.props.title && (
                                            <Link to=".">
                                                <div className="c-page__return">
                                                    <IconChevronLeft /> {this.props.return}
                                                </div>
                                            </Link>
                                        )}
                                </div>
                                <div className="c-page__center">{this.props.center}</div>
                                <div className="c-page__right">
                                    {window.matchMedia(
                                        "(min-width:" + GlobalConfig.ui.breakpoints.sm + "px)"
                                    ).matches && this.props.actionsLarge}
                                    {window.matchMedia(
                                        "(max-width:" + (GlobalConfig.ui.breakpoints.sm - 1) + "px)"
                                    ).matches && this.props.actionsSmall}
                                </div>
                            </div>
                        </header>
                        <section className="c-page__body">
                            <div className="c-page__body-container">{this.props.children}</div>
                            <div className={updatingClasses.join(" ")}>
                                <Loading message={this.props.updatingMessage} />
                            </div>
                        </section>
                    </section>
                    {/* end of what used to be the PageContent component*/}
                </section>
                <footer className="o-site__footer">
                    <div title={this.state.version} className="o-site__footer-logo">
                        {window.innerWidth >= 992 && <IconLogoHorizontal />}
                        {window.innerWidth < 992 && <IconLogoVertical />}
                    </div>
                    <div className="o-site__footer-links">
                        <ul>
                            <li>
                                <a
                                    href={Routing.Marketing.POLICY_TERMS}
                                    className="c-link no-underline">
                                    terms of use
                                </a>
                            </li>
                            <li>
                                <a
                                    href={Routing.Marketing.POLICY_PRIVACY}
                                    className="c-link no-underline">
                                    privacy policy
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="o-site__footer-legal">
                        &copy; {Moment().format("YYYY")} Relode, LLC.{" "}
                        <span>All Rights Reserved</span>
                    </div>
                </footer>
            </div>
        );
    }
}
